import jsuper from '@/assets/js/jsuperV2.js'

/**
 * 函数防抖（用于计算点赞数）
 * @param { Function } fn 要执行的函数
 * @param { Number } t 时间
 */
export const debounce = (fn, t) => {
  let delay = t || 1000
  let timer

  return function() {
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = null
      fn.apply(this, args)
    }, delay)
  }
}

export const getQuery = (N) => {
  if (window.location.hash.split('=')[N]) {
    let val = window.location.hash.split('=')[N].split('&')[0]
    return val
  }
  return ''
}

const ua = navigator.userAgent.toLowerCase(),
  isIOS = ua.match(/iphone|ipad|ipod/i),
  isAndroid = !isIOS,
  isSuperBrowser = !!~ua.indexOf('superfriday'),
  isWXBrowser = !!~ua.indexOf('micromessenger')
export const utils = {
  isIOS: isIOS,
  isAndroid: isAndroid,
  isSuperBrowser: isSuperBrowser,
  isWXBrowser: isWXBrowser,
}

export const setAppShare = () => {
  jsuper.showShareMenu()
}
export const setShare = () => {
  let platform = ['weixinTimeline', 'weixinSession', 'weibo', 'qzone'],
    shareDataWeChat = {},
    shareDataQzone = {},
    shareDataWeibo = {},
    shareDataCircle = {}
  let normalIcon = 'https://a.super.cn/generatingTimetable/logo.jpg'
  if (isSuperBrowser) {
    jsuper.browserConfig({
      data: {
        openWithBrowser: 0, //是否允许外部浏览器打开
        orientation: 1, //横竖屏,1竖屏,2横屏,3跟随手机方向
      },
    })
    jsuper.shareItems({
      platform: platform,
    })
    ;(shareDataWeChat = {
      //分享微信
      title: '这是我未来的大学课表，快来看看你的吧！',
      content: '一键生成你的大学课程表！',
      titleUrl: window.location.origin + window.location.pathname + '?way=wechat',
      shareUrl: window.location.origin + window.location.pathname + '?way=wechat',
      // shareImgUrl: normalIcon, //分享的图片链接
      // icon: normalIcon //分享的图片链接
    }),
      (shareDataWeibo = {
        //分享微信
        title: '这是我未来的大学课表，快来看看你的吧！',
        content: '一键生成你的大学课程表！',
        titleUrl: window.location.origin + window.location.pathname + '?way=weibo',
        shareUrl: window.location.origin + window.location.pathname + '?way=weibo',
        shareImgUrl: normalIcon, //分享的图片链接
        icon: normalIcon, //分享的图片链接
      }),
      (shareDataQzone = {
        //分享微信
        title: '这是我未来的大学课表，快来看看你的吧！',
        content: '一键生成你的大学课程表！',
        titleUrl: window.location.origin + window.location.pathname + '?way=qzone',
        shareUrl: window.location.origin + window.location.pathname + '?way=qzone',
        shareImgUrl: normalIcon, //分享的图片链接
        icon: normalIcon, //分享的图片链接
      }),
      (shareDataCircle = {
        //分享朋友圈
        title: '这是我未来的大学课表，快来看看你的吧！',
        content: '一键生成你的大学课程表！',
        titleUrl: window.location.origin + window.location.pathname + '?way=circle',
        shareUrl: window.location.origin + window.location.pathname + '?way=circle',
        // shareImgUrl: normalIcon, //分享的图片链接
        // icon: normalIcon //分享的图片链接
      })
    jsuper.shareWeixinSessionConfig(shareDataWeChat) //微信好友
    jsuper.shareWeixinTimelineConfig(shareDataCircle) //微信朋友圈jsuper.shareWeiboConfig(shareData); //微博
    jsuper.shareQzoneConfig(shareDataQzone) //QQ空间
    jsuper.shareWeiboConfig(shareDataWeibo) //微博

    // let shareWeixinSessionConfig = data ? data.institute ? _.extend({}, shareData, { title: '跟我一起报名第二大学，暑假去企业工作实践吧！' }) : shareData : shareData;
    // isLowVersion && data && jsuper.shareFeedConfig(_.extend({}, shareData, { content: shareData.title })); //Feed流
  }
}

// 获取链接上的参数
export function getUrlParams(url, query) {
  if (!url.split('?')[1]) return ''
  const allQuery = url.split('?')[1].split('&')
  const queryObj = {}
  for (const item of allQuery) {
    let key = item.split('=')[0]
    let value = item.split('=')[1]
    if (value.indexOf('#') > -1) {
      value = value.substring(0, value.indexOf('#'))
    }
    queryObj[key] = value
  }
  console.log(queryObj, 'queryObj')
  return queryObj[query]
}
